import { render, staticRenderFns } from "./CompanyIncorporationTask.vue?vue&type=template&id=3e2940ac&scoped=true&"
import script from "./CompanyIncorporationTask.vue?vue&type=script&lang=js&"
export * from "./CompanyIncorporationTask.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIncorporationTask.vue?vue&type=style&index=0&id=3e2940ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2940ac",
  null
  
)

export default component.exports